module.exports = __webpack_public_path__ + "static/media/m10tj93.61624c84.png";